import React from "react";
import { BaseIconProps } from "../../types/styles";

const WarningIcon = ({
    id,
    className,
    size = 24,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--shade-white)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-warning"}
            className={className}
            width={size}
            height={(Number(size) * 24) / 22}
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.2107 1.19901C12.6726 0.266995 11.3274 0.266996 10.7893 1.19901L0.189386 19.5586C-0.348715 20.4906 0.323911 21.6556 1.40011 21.6556H22.5999C23.6761 21.6556 24.3487 20.4906 23.8106 19.5586L13.2107 1.19901ZM13.0503 14.2828V7.9806H10.9496V14.2828H13.0503ZM13.0503 18.4842V16.3835H10.9496V18.4842H13.0503Z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill={color}
            />
        </svg>
    );
};

export default WarningIcon;
